export type QuestionType =
  | 'text'
  | 'optional_text'
  | 'radio'
  | 'checkbox'
  | 'attachment';
export type ETIStatus = 'PUBLISHED' | 'SUBMITTED' | 'DRAFT' | 'WAIVED';

export interface EtiSectionMetadata {
  sectionName: string;
  description: string;
}

export interface ETIQuestion {
  idx: number;
  section: string;
  question: string;
  questionType: QuestionType;
  options?: string[];
  filter?:
    | { [dependsOnIdx: string]: string | string[] }
    | { [dependsOnIdx: number]: string | string[] };
}

// Version 1 Answer format (legacy structured format)
export interface ETIAnswerV1 {
  idx: number;
  section: string;
  question: string;
  questionType: QuestionType;
  userAnswer: string;
}

// Version 2 Answer format (SurveyJS key-value pairs)
// Keys are question names like "Physician Care_q1", values are the answers
export type SurveyJSAnswers = Record<string, any>;

// Base interface for common ETI properties
interface ETIBase {
  id: number;
  policyId: number;
  taskId: number;
  status: ETIStatus;
  questions: {
    questions: ETIQuestion[];
    sectionMetadata?: EtiSectionMetadata[];
  };
  createdAt: string;
  updatedAt: string | null;
  publishedAt: string | null;
  submittedAt: string | null;
}

// Version 1 ETI with structured answers
export interface ETIV1 extends ETIBase {
  version: 1;
  answers: { answers: ETIAnswerV1[] } | null;
}

// Version 2 ETI with SurveyJS answers
export interface ETIV2 extends ETIBase {
  version: 2;
  answers: SurveyJSAnswers | null;
  surveySchema: any;
}

// Discriminated union - ETI is either V1 or V2
export type ETI = ETIV1 | ETIV2;

export function isETIV1(eti: ETI | null): eti is ETIV1 {
  return eti?.version === 1;
}

export function isETIV2(eti: ETI | null): eti is ETIV2 {
  return eti?.version === 2;
}

export interface QuestionFormData {
  section: string;
  question: string;
  questionType: QuestionType;
  options?: string[];
  filter?:
    | { [dependsOnIdx: string]: string | string[] }
    | { [dependsOnIdx: number]: string | string[] };
  optionsRaw?: string;
  filterRaw?: string;
}

export interface SectionMetadataFormData {
  sectionName: string;
  description: string;
}

export interface ETIFormData {
  taskId: number;
  status: ETIStatus;
  questions: QuestionFormData[];
  sectionMetadata?: SectionMetadataFormData[];
}
